import React, {forwardRef, useRef, useState} from "react";
import classNames from "classnames";
import {Error} from "@/Components/Error";
import Svg from "@/Components/Svg";
import {Label} from "@/Components/Label";
import Input from "@/Components/Input";
import MaskedInput from "@/Components/MaskedInput";

export default forwardRef(function TextInput(props, ref) {
    const {
        as,
        mask,
        label = '',
        type = 'text',
        name = '',
        value = '',
        autoComplete,
        required = false,
        disabled = false,
        fake = false,
        isFocused,
        onChange = () => {
        },
        onFocus = () => {
        },
        onBlur = () => {
        },
        className = '',
        labelClassName = '',
        inputClassName = '',
        errorClassName = '',
        style = {},
        message,
        ...rest
    } = props;

    const inputRef = ref ? ref : useRef(null);
    const [isFocusedInternal, setIsFocusedInternal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const isPasswordType = type === 'password';
    const inputType = isPasswordType ? (showPassword ? 'text' : 'password') : type;

    /**
     * Показать / скрыть пароль
     */
    const togglePasswordVisibility = () => {
        if (isPasswordType) {
            setShowPassword(prev => !prev);
        }
    };

    const isFocusedResult = typeof isFocused === 'boolean' ? isFocused : isFocusedInternal;

    const handleFocus = (e) => {
        if (typeof isFocused !== 'boolean') {
            setIsFocusedInternal(true);
        }
        onFocus(e);
    };

    const handleBlur = (e) => {
        if (typeof isFocused !== 'boolean') {
            setIsFocusedInternal(false);
        }
        onBlur(e);
    };

    const formItemClassName = classNames('formItem', className, {
        'formItem--filled': !!value || isFocusedResult || type === 'date' || String(value).length > 0,
        'formItem--disabled': disabled,
        'formItem--fake': fake,
        'formItem--error': message,
        'formItem--eye': isPasswordType,
    });

    // Рендерим в зависимости от mask
    const InputComponent = mask ? (
        <MaskedInput
            ref={inputRef}
            type={inputType}
            name={name}
            value={value}
            placeholder={label}
            autoComplete={autoComplete}
            required={required}
            disabled={disabled}
            className={inputClassName}
            style={style}
            mask={mask}
            message={message}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            {...rest}
        />
    ) : (
        <Input
            ref={inputRef}
            as={as}
            type={inputType}
            name={name}
            value={value}
            placeholder={label}
            autoComplete={autoComplete}
            required={required}
            disabled={disabled}
            className={inputClassName}
            style={style}
            message={message}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            {...rest}
        />
    );

    return (
        <div className={formItemClassName}>
            <Label htmlFor={name} className={labelClassName}>{label}</Label>
            {InputComponent}
            {isPasswordType && (
                <div className={`eye`} onClick={togglePasswordVisibility}>
                    {showPassword
                        ? <Svg id={`closedEye`} className={`svg__closedEye`} />
                        : <Svg id={`openEye`} className={`svg__openEye`} />
                    }
                </div>
            )}
            <Error message={message} className={errorClassName} />
        </div>
    );
});
